import { FC } from 'react';
import DemographicsHeader from './DemographicsHeader/DemographicsHeader';
import { DemographicsProps } from './Demographics.types';
import DemographicsListView from './DemographicsListView/DemographicsListView';
import { useDemographicsFilters } from '@modules/study-insights/hooks';

const Demographics: FC<DemographicsProps> = ({ data, selectedPillId }) => {
  const { handleFilterChange, reducedData, isFilteringData } = useDemographicsFilters({ data, selectedPillId });

  return (
    <>
      <DemographicsHeader
        data={data}
        data-testid="demographics-header"
        selectedPillId={selectedPillId}
        handleDataFilterChange={handleFilterChange}
      />
      {!isFilteringData && <DemographicsListView data={reducedData} />}
    </>
  );
};

export default Demographics;
